import classes from '../index.module.css';
import React, { useEffect, useState } from 'react';
import TabsComponent from '../../../components/Tabs/Tabs';
import MFRRMonitoring from './MFRRMonitoring';
import MfrrLogs from './MfrrLogs';
import { useQueryParamWithDefault } from '../../../hooks';
import { NumberParam } from 'use-query-params';
import MfrrPowerLogs from './MfrrPowerLogs';

const MFRRMonitoringEvents = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'DK1',
            component: (
                <>
                    <MFRRMonitoring area={'DK1'} cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'DK2',
            component: (
                <>
                    <MFRRMonitoring area={'DK2'} cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

const MFRRMonitoringCommandLogs = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'MFRR Logs',
            component: (
                <>
                    <MfrrLogs cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'MFRR Power Logs',
            component: (
                <>
                    <MfrrPowerLogs cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

const MFRRMonitoringMainAdmin = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('tab', NumberParam, 0, cId);

    let tabs = [
        {
            name: 'Events',
            component: (
                <>
                    <MFRRMonitoringEvents cId={cId} />
                </>
            ),
            tabId: 1,
        },
        {
            name: 'Command Logs',
            component: (
                <>
                    <MFRRMonitoringCommandLogs cId={cId} />
                </>
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={classes.Ventilation + ' ventilation'}>
            <TabsComponent
                selectedIndex={selectedIndex}
                tabs={tabs}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default MFRRMonitoringMainAdmin;
